import type { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import type { AxiosError, AxiosRequestConfig } from 'axios';
import { request, type RequestConfig } from 'utils/http';
import history from 'utils/history';
import { isMaintenanceModeResponse } from 'utils/maintenance';

type BaseQueryReturnFunctionType = BaseQueryFn<
  {
    url: string;
  } & AxiosRequestConfig,
  unknown,
  unknown
>;

export const baseQuery = ({
  baseUrl = ''
}: { baseUrl?: string } = {}): BaseQueryReturnFunctionType => {
  const fn = async ({ url, ...config }: RequestConfig) => {
    try {
      const result = await request({ url: baseUrl + url, ...config });
      return { data: result };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      const status = err.response?.status;
      const data = err.response?.data as unknown;

      /**
       * Перенаправляем на страницу технических работ, когда API ответил HTTP 503
       * с кодом MAINTENANCE_MODE и пользователь ещё не находится на этой странице.
       * DEVELOPMENT-446: https://tracker.yandex.ru/DEVELOPMENT-446
       */
      if (
        isMaintenanceModeResponse(status, data) &&
        history.location.pathname !== '/maintenance'
      ) {
        history.replace('/maintenance');
      }

      return {
        error: { status, data }
      };
    }
  };
  return fn;
};
